"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = (0, tslib_1.__importDefault)(require("react"));
const Svg_1 = (0, tslib_1.__importDefault)(require("./Svg"));
const SvgBatteryEmpty = (_a) => {
    var { size = 24 } = _a, props = (0, tslib_1.__rest)(_a, ["size"]);
    return (react_1.default.createElement(Svg_1.default, Object.assign({ fill: "currentColor", viewBox: "0 0 25 24", size: size }, props),
        react_1.default.createElement("path", { fill: "currentColor", d: "M21.78 9h1.5a1.5 1.5 0 011.5 1.5v3a1.5 1.5 0 01-1.5 1.5h-1.5v1.5a1.5 1.5 0 01-1.5 1.5h-2.137l-12-12h14.138a1.5 1.5 0 011.5 1.5V9zM.78 7.5A1.5 1.5 0 012.28 6h1.08l12 12H2.28a1.5 1.5 0 01-1.5-1.5v-9z" }),
        react_1.default.createElement("path", { fill: "currentColor", d: "M20.42 20.301L5.107 4.99c-.432-.433-.45-1.064-.111-1.402.337-.338 1.005-.285 1.401.112L21.71 19.01c.432.433.45 1.064.112 1.402-.338.338-1.006.285-1.402-.112z" })));
};
exports.default = SvgBatteryEmpty;
//# sourceMappingURL=BatteryEmpty.js.map